import Page from 'navigation/SuperPage'

class Project extends Page {

}

Project.pageName = 'Project'

export default Project
